<template>
	<Col v-if="isLoading" class="width-100 height-100 flex-centerize">
		<AppLoader />
	</Col>
	<Col v-else class="width-100 height-100 pt-7 pr-6">
		<Row class="flex-align-center">
			<AnemicButton @click="goBack" class="back-button mr-2" width="25" height="25" fab x-small>
				<AppIcon name="back" />
			</AnemicButton>
			<IssueCardIconAndTexts :issue="issue" />
		</Row>
		<TaskLog class="overflow-hidden" :errorMessage="issueId" :workflowId="workflowId" searchDisabled />
	</Col>
</template>
<script>
import createAndManageService from '../AppLayout/ManageAndCreate/create-and-manage-service';
import { ISSUES_ROUTE_NAME, ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME } from '@/router/router.const';
import { useIssue } from '@/store/modules/issues/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import TaskLog from '@/views/AppContentPages/TaskLog.vue';
import IssueCardIconAndTexts from '@/views/IssuesView/IssueCardIconAndTexts.vue';
export default {
	name: ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME,
	components: {
		TaskLog,
		IssueCardIconAndTexts,
	},
	props: {
		issueId: { type: String, required: true }, // for now, use the issue error_message as the issue id, until BE will arrange it differently
		workflowId: { type: Number, required: true },
	},
	computed: {
		...mapGettersShorthand({ useIssue }),
		issue() {
			return this.useIssue(this.issueId);
		},
		routePrefix() {
			return createAndManageService.getPlacementRoutePrefix(this.$route);
		},
	},
	methods: {
		goBack() {
			this.$router.push({ name: this.routePrefix + ISSUES_ROUTE_NAME });
		},
	},
	async created() {
		if (!this.issue) {
			this.isLoading = true;
			try {
				// TODO: get issue by id/error_message
			} catch (e) {
				console.error(e);
				this.$toast.error('Failed to load issue data, please try again later.');
			} finally {
				this.isLoading = false;
			}
		}
	},
	data() {
		return {
			isLoading: false,
		};
	},
};
</script>

<style scoped lang="scss"></style>
